module.exports = __webpack_public_path__ + "img/Loose Pin.0a20a49d.png";